export const WIDTH_PROJECTS_COLUMN = 5
export const WIDTH_WEEKDAYS_COLUMN = 2
export const WIDTH_TABLE = 20
export const TOTAL_DAY_MINUTES = 1440

export const DEFAULT_CURRENCY = 'EUR'

export enum graphViewsDetailViewOptionEnum {
  employees = 'employees',
  subprojects = 'subprojects',
}

export enum graphViewsCostOptionEvolutionEnum {
  evolution = 'evolution',
  breakdown = 'breakdown',
}

export const projectAttributes = {
  projectName: 'name',
  projectCode: 'code',
  projectDescription: 'description',
  startDate: 'startDate',
  dueDate: 'dueDate',
  client: 'client',
} as const

export enum financialDetailsAttributes {
  legalEntityId = 'legalEntityId',
  fixedCost = 'fixedCost',
  isBillable = 'isBillable',
  currencyType = 'currencyType',
}

export enum overviewFilterOptionsEnum {
  currentWeek = 'current_week',
  lastWeek = 'last_week',
  currentMonth = 'current_month',
  lastMonth = 'last_month',
  customRange = 'custom_range',
  wholeProject = 'whole_project',
}

export enum overviewFrequencyOptionsEnum {
  daily = 'days',
  weekly = 'weeks',
  monthly = 'months',
  yearly = 'years',
}

export enum budgetTypesEnum {
  fixedTimeBudget = 'fixed_time_budget',
  fixedCostPlanning = 'fixed_cost_planning',
  withoutBudget = 'without_budget',
}

export enum maxMinutesPerCurrentWeekTypes {
  estimated = 'estimated',
  worked = 'worked',
}

export enum offDayTypesEnum {
  holidaysCompanyHoliday = 'HolidaysCompanyHoliday',
  timeoffLeave = 'TimeoffLeave',
  timePlanningEstimatedWorkDay = 'TimePlanningEstimatedWorkDay',
  withoutOffDay = 'WithoutOffDay',
}
